import { takeLatest, put } from 'redux-saga/effects';
import { createPortfolio } from './routines';
import type { CreatePortfolioPayload } from './actions';
import { createPortfolio as createPortfolioService } from '@simplywallst/services';
import { fetchPortfolioList } from '@/components/DeprecatedPortfolio/redux/routines';
import { getAuthenticatedAhoy } from '@ducks/saga';
import type { CurrencyISO } from '@/utilities/countries';

function* createPortfolioRequest(name: string, currency = 'USD') {
  try {
    yield put(createPortfolio.request());
    const caller = getAuthenticatedAhoy();
    return yield caller(createPortfolioService, {
      name,
      sharing: 'false',
      currency_iso: currency,
      include: 'items,items.transactions',
    });
  } catch (reason) {
    console.error('createPortfolioRequest caught', reason);
    return reason;
  }
}

export function* createNewPortfolioSaga(
  portfolioName: string,
  currency: CurrencyISO
) {
  // create portfolio
  let safeCurrency = currency;
  if (safeCurrency.length === 0) {
    safeCurrency = 'USD';
  }
  const portfolio = yield createPortfolioRequest(portfolioName, currency);
  try {
    yield put(
      createPortfolio.success({
        id: portfolio.data.id,
        name: portfolioName,
      })
    );
    return portfolio.data.id;
  } catch (error: any) {
    console.error('createNewPortfolioSaga caught', {
      message: error.message,
      stack: error.stack,
    });
  }
}

export function* createAndFetchNewPortfolioSaga(action) {
  const { portfolioName, currency } = action.payload as CreatePortfolioPayload;
  try {
    const response = yield createPortfolioRequest(portfolioName, currency);
    if (response && response.data && response.data.id) {
      yield put(fetchPortfolioList.trigger());
      yield put(
        createPortfolio.success({
          id: response.data.id,
          name: portfolioName,
        })
      );
    } else {
      yield put(
        createPortfolio.failure({
          message:
            (response.errors &&
              response.errors[0] &&
              response.errors[0].title) ||
            'Unable to create portfolio',
        })
      );
    }
  } catch (reason) {
    console.error('createAndFetchNewPortfolioSaga caught', reason);
    yield put(
      createPortfolio.failure({
        message: 'Unable to create portfolio',
      })
    );
  } finally {
    yield put(createPortfolio.fulfill());
  }
}

/** Watchers */

function* watchCreatePortfolioTrigger() {
  yield takeLatest(createPortfolio.TRIGGER, createAndFetchNewPortfolioSaga);
}

export const exportableSagas = [watchCreatePortfolioTrigger];
